import { Button, ButtonProps } from "@mui/material";
import * as React from "react";
import { useLanguage } from "../../Language";
import PlaceIcon from "@mui/icons-material/Place";

export const StackMapButton: React.FC<ButtonProps> = (props) => {
  const { translate } = useLanguage();
  return (
    <Button
      sx={{ textTransform: "none" }}
      variant="outlined"
      startIcon={<PlaceIcon />}
      {...props}
    >
      {translate("stackMapIt")}
    </Button>
  );
};
